import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardApplyList } from "@/types";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async applyList(idx: number, param: types.ReqCommonPaging): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/list/apply/campaign2/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(idx: number): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(
                `/board/export/excel/apply/campaign2/${idx}`,
                {},
                {
                    withCredentials: false,
                    responseType: "blob",
                },
            );

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
